import React from 'react'
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';
import Hack4TTSModalPopup from './IntroPopup/Hack4tts_modalPopup';
import Hack4TTSModalAboutDataset from './About_infos/Hack4tts_modalAboutDataset';
// Import your logos (adjust paths as needed)
// import BhashiniLogo from './assets/bhashini.png'
// import IIScLogo      from './assets/iisc.png'
// import ArtparkLogo   from './assets/artpark.png'
// import GIZLogo       from './assets/giz.png'
// import SammaanLogo   from './assets/sammaan.png'

export default function About({ section_id }) {
    // card definitions
    const cards = [
      {
        icon: application_contants.micicon ,
        title: 'Accent Transfer',
        text:  'Ensures TTS output is regionally accurate and culturally relatable.'
      },
      {
        icon: application_contants.styleicon ,
        title: 'Style Transfer',
        text:  'Enables emotional, natural-sounding speech with minimal data.'
      },
      {
        icon: application_contants.globalicon ,
        title: 'Text Normalization',
        text:  'Handles linguistic complexity and mixed-language inputs for smoother synthesis.'
      }
    ]
     // partners definitions
    const partners = [
      {
        image: application_contants.bhashinilogo ,
        title: 'Bhashini',
        text:  'An initiative under India’s National Language Translation Mission (NLTM), Bhashini is building a public digital platform for Indian language AI solutions, enabling access to digital services in every Indian language.'
      },
      {
        image: application_contants.iisclogo ,
        title: 'IISc',
        text:  'The Indian Institute of Science (IISc), Bengaluru, founded in 1909, is India’s leading institution for advanced research and higher education in science and engineering. '
      },
      {
        image: application_contants.spirelogo ,
        title: 'SPIRE Lab',
        text:  'Signal Processing Interpretation and REpresentation Lab. SPIRE is one of IISc’s advanced research labs in AI, speech processing, and machine learning, led by Dr. Prasanta Kumar Ghosh.'
      },
      {
        image: application_contants.artparklogo ,
        title: 'ARTPARK',
        text:  'An AI & Robotics innovation foundation at IISc, ARTPARK leads deep-tech projects by connecting research, startups, and government to build scalable AI solutions across sectors.'
      },
      {
        image: application_contants.gizlogo ,
        title: 'GIZ FAIR Forward',
        text:  'In partnership with Bhashini and IISc, GIZ’s FAIR Forward initiative supports the development of language technologies and speech corpora in nine Indian languages to promote inclusive digital access.'
      },
      {
        image: application_contants.armmanlogo ,
        title: 'ARMMAN',
        text:  'A non-profit using technology to improve maternal and child health in India. ARMMAN’s large-scale mobile health programs like Kilkari reach millions of women and frontline workers with vital health information.'
      }
    ]
  return (
    <section id={section_id} className="about-section">
      <div className="about-content">
        {/* <p className="about-subtitle title-navy-blue">Know More About us</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title ">Voice Tech for All: Introduction</h2>
        <iframe class="introduction-responsive-video" src="https://www.youtube.com/embed/3JKOw1ICdQE?si=y7de2pV9_-NgaXfP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        <p className="jostRegular h5-small section-title title-dark-grey about-text">
          The development of Text-to-Speech (TTS) systems tailored to low-resource Indian languages has the potential to revolutionize accessibility, education, and digital communication across diverse regions. This hackathon aims to address the challenge of creating TTS models that support accent and style transfer for SYSPIN's 9 languages (Hindi, Bengali, Marathi, Telugu, Bhojpuri, Kannada, Magadhi, Chhattisgarhi, and Maithili), as well as languages of SPICOR TTS corpora, namely, English and Gujarati. By leveraging open-source datasets and fostering innovation, the Challenge seeks to advance TTS technology for underrepresented languages and styles, empowering communities with localized and expressive voice synthesis.
        </p>

        <Hack4TTSModalPopup />
      </div>

      <div className="challenge-cards">
        {cards.map(({ icon, title, text }) => (
          <div key={title} className="challenge-card">
            <div className="card-icon">
              <img src={icon} alt="" />
            </div>
            <h3>{title}</h3>
            <p className="jostRegular h6-small section-title about-box-text">{text}</p>
          </div>
        ))}
      </div>     

 <br/>    
      <div className="about-content">
        {/* <p className="about-subtitle title-navy-blue">Know More About Datasets</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Datasets</h2>
        <p className="jostRegular h5-small section-title title-dark-grey about-text">
          The SYSPIN Dataset is a groundbreaking resource developed by SPIRE Lab, IISc Bangalore, in collaboration with Bhashini AI Solutions Pvt Ltd. It is supported by the German Development Cooperation project FAIR Forward - AI for All and (GIZ) and the Digital India Bhashini Division aimed at revolutionising open-source voice technology for diverse Indian languages.
        </p>

        {/* <br/>         */}
        <Hack4TTSModalAboutDataset />
      </div>
      <br/>

      <div className="about-content">
        {/* <p className="about-subtitle title-navy-blue">Know More About Partners</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Partners</h2>

        <div className="challenge-cards">
          {partners.map(({ image, title, text }) => (
            <div key={title} className="challenge-card">
              <div className="about-logos">
                <img src={image} alt="" />
              </div>
              <h3>{title}</h3>
              <p className="jostRegular h6-small section-title about-box-text">{text}</p>
            </div>
          ))}
        </div> 
      </div>


    </section>
  )
}

About.propTypes = {
  section_id: PropTypes.string.isRequired
}
